import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Promo1 from '../../images/promo/ts_runthetrickstrat.jpg';
import {getRandomPromo,getRandomGears4Promo,getRandomLawBreakersPromo,getRandomRS6Promo} from '../../utils/promos/promoUtil.js';
import {
  GEARS4,
  TRICKSTRAT,
  LAWBREAKERS,
  RS6,
  GEARS5
} from '../../utils/maps/types';
class Promo extends Component {

render () {
  var {map, game} = this.props;
  var promo;
  if (game == TRICKSTRAT || game == undefined || game == GEARS5)
  {
      promo = getRandomPromo(Math.floor(Math.random() * 2));
  }
  if (game == GEARS4)
  {
    promo = getRandomGears4Promo(Math.floor(Math.random() * 1));
  }
  if (game == LAWBREAKERS)
  {
    promo = getRandomLawBreakersPromo(Math.floor(Math.random() * 1));
  }
  if (game == RS6)
  {
    promo = getRandomRS6Promo(Math.floor(Math.random() * 1));
  }
var img =  <span><img width="100%" src={promo}></img></span>
    return (
      <div className='ad'>
        {img}
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({

    }, dispatch);
}

function mapStateToProps(state) {
    return { map:state.map };
}

export default connect(mapStateToProps, mapDispatchToProps)(Promo);



// WEBPACK FOOTER //
// ./src/app/components/promo/index.jsx